import { AlbumIcon } from './AlbumIcon';

/**
 * author: Google
 * id 8529D611-F581-4808-95BE-271FB1A6C2FD
 * name album
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/album.svg
 * tags
 * - Audio 
 * - Music 
 */
export const VinylIcon = AlbumIcon;
export default VinylIcon